import React from "react";
import { ConnectedConfiguratorScreen } from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen";
import { CreatorScreen as BaseCreatorScreen } from "@configuratorware/configurator-frontendgui/App/Modules/Creator/CreatorScreen";
import BaseOptionsListContainer
  from "@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/OptionsList";
import BaseProductPartsListContainer
  from "@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList";
import CustomOption from "../Components/CustomOption";
import CustomOptionList from "../Components/CustomOptionList";
import AddToCartComment from "../Components/AddToCartComment";
import GroupedConfiguratorScreen from "../Components/GroupedConfiguratorScreen/GroupedConfiguratorScreen";
// import LogoUpload from '../Components/LogoUpload';
import ThemeProvider from "../ThemeProvider";
import CustomAmountPrice from "../Components/CustomAmountPrice";
import ProductPartsList from "../Components/ProductPartsList";
import LandscapeInformation from "../Components/LandscapeInformation";

const OptionsListContainer = (props) => (
  <BaseOptionsListContainer
    {...props}
    OptionComponent={CustomOption}
    Component={CustomOptionList}
  />
);

const CreatorScreen = (props) => (
  <BaseCreatorScreen
    {...props}
    OptionsListContainer={OptionsListContainer}
    renderPriceBox={({ setConfigurationComment, userComment, ...props }) => {
      return (
        <>
          <AddToCartComment
            setConfigurationComment={setConfigurationComment}
            userComment={userComment}
          />
          <CustomAmountPrice {...props} />
          {/* {props.renderDefaultPriceBox()} */}
        </>
      );
    }}
    renderProductParts={(dispatchAction, onOptionClassificationSelect, selectOptionClassification) => (
      <BaseProductPartsListContainer
        onSelect={optionClassification =>
          onOptionClassificationSelect(dispatchAction, optionClassification, selectOptionClassification)
        }
        vertical={false}
        Component={ProductPartsList}
      />
    )}
    vertical={false}
  />
);

const ConfiguratorScreen = (props) => {
  const Component = (
    <ConnectedConfiguratorScreen
      {...props}
      renderLandscapeInformation={() => <LandscapeInformation/>}
      CreatorScreen={CreatorScreen}
      ThemeProvider={ThemeProvider}
    />
  );

  return <GroupedConfiguratorScreen Component={Component}/>;
};

export default ConfiguratorScreen;
